import {
  FilingCaseType,
  FilingType,
  PndStatus,
  PndTableSortColumnType,
  PndTableViewStatusType,
  PndType,
  TaxDocumentType,
  TransactionTableSortColumnType,
  VerifyType,
  WhtCertificateTableSortColumnType,
} from "@/enums/enums";
import { i18n } from "@/i18n";
import { CompareDataListForSorting, NewObject } from "./shareHelper";

export function GetPndCreateTemplate() {
  const pndCreateTemplate = {
    id: 0,
    pndType: PndType.PND53,
    pndTypeNumber: "",
    taxPeriodDate: {
      value: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      validateError: false,
    },
    filingType: {
      value: FilingType.None,
      name: "",
    },
    times: {
      value: 0,
    },
    number: {
      value: "",
    },
    subTotal: {
      value: "0.00",
      validateError: false,
    },
    whtTotal: {
      value: "0.00",
      validateError: false,
    },
    surchargeAmount: {
      value: "0.00",
      validateError: false,
    },
    netAmount: {
      value: "0.00",
      validateError: false,
    },
    status: 0,
    filingTaxSection: FilingCaseType.M3Sec3,
    isVerified: false,
    whtCertificateList: [] as any,
    merchant: {
      merchantId: 0,
      merchantName: "",
      merchantTaxId: "",
      merchantBranchCode: "",
      building: "",
      roomNo: "",
      floorNo: "",
      homeGroup: "",
      no: "",
      homeno: "",
      soi: "",
      road: "",
      district1: "",
      district2: "",
      province: "",
      postCode: "",
    },
    countWhtCertificate: 0,
    isUpdateTable: false,
  };

  return pndCreateTemplate;
}

export function GetPndNumberByPndType(pndType: PndType) {
  let pndTypeNumber = "";
  switch (pndType) {
    case PndType.PND1:
      pndTypeNumber = "1";
      break;
    case PndType.PND2kor:
      pndTypeNumber = "2ก";
      break;
    case PndType.PND2:
      pndTypeNumber = "2";
      break;
    case PndType.PND3:
      pndTypeNumber = "3";
      break;
    case PndType.PND3kor:
      pndTypeNumber = "3ก";
      break;
    case PndType.PND53:
      pndTypeNumber = "53";
      break;
    case PndType.PND54:
      pndTypeNumber = "54";
      break;
  }
  return pndTypeNumber;
}

export function SetHeadertWhtCertificateTableByPeriodTaxTable(isCheck = false) {
  const header = [
    {
      name: "check",
      hidden: isCheck ? false : true,
      checkAll: false,
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "WHT_No",
      sortBy: WhtCertificateTableSortColumnType.WhtCertificateNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Date",
      sortBy: WhtCertificateTableSortColumnType.WhtCertificateDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Withholding_Tax_Contact",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Text_IncomeType",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Payment_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Wht_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  return header;
}
export function SetHeadertWhtCertificateTableForDetail(isCheck = false) {
  const header = [
    {
      name: "check",
      hidden: isCheck ? false : true,
      checkAll: false,
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "WHT_No",
      sortBy: WhtCertificateTableSortColumnType.WhtCertificateNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Date",
      sortBy: WhtCertificateTableSortColumnType.WhtCertificateDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Withholding_Tax_Contact",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Text_IncomeType",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Payment_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Wht_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  return header;
}
export function SetTablePage(
  pageNumber: number,
  pageSize: number,
  detailList: Array<any>,
  sortBy: number,
  sortingType: number,
  taxDocumentType: TaxDocumentType,
  searchText: string
) {
  
  switch (taxDocumentType) {
    case TaxDocumentType.WithHoldingTax:
      {
        if(searchText)
        {
          detailList = detailList.filter(function(item: any) {
            return item.whtNumber.toLowerCase().includes(searchText.toLowerCase())|| 
            item.contactFullName.toLowerCase().includes(searchText.toLowerCase())});
        }
        switch (sortBy) {
          case WhtCertificateTableSortColumnType.WhtCertificateNumber:
            detailList.sort((a: any, b: any) => {
              return CompareDataListForSorting(a.whtNumber.toLowerCase(), b.whtNumber.toLowerCase(), sortingType);
            });
            break;
          case WhtCertificateTableSortColumnType.WhtCertificateDate:
            detailList.sort((a: any, b: any) => {
              return CompareDataListForSorting(a.whtDate, b.whtDate, sortingType);
            });
            break;
        }
      }
      break;
    case TaxDocumentType.PP30Transaction:
      {
      if(searchText)
        {
          detailList = detailList.filter(function(item: any) {
            return item.taxInvoiceNumber.toLowerCase().includes(searchText.toLowerCase()) || 
            item.reference.toLowerCase().includes(searchText.toLowerCase()) || 
            item.contactFullName.toLowerCase().includes(searchText.toLowerCase());
          });
        }
        switch (sortBy) {
          case TransactionTableSortColumnType.TaxInvoiceNumber:
            detailList.sort((a: any, b: any) => {
              return CompareDataListForSorting(
                a.taxInvoiceNumber.toLowerCase(),
                b.taxInvoiceNumber.toLowerCase(),
                sortingType
              );
            });
            break;
          case TransactionTableSortColumnType.TaxInvoiceDate:
            detailList.sort((a: any, b: any) => {
              return CompareDataListForSorting(a.taxInvoiceDate, b.taxInvoiceDate, sortingType);
            });
            break;
        }
      }
      break;
  }
  const start = pageNumber == 1 ? 0 : (pageNumber - 1) * pageSize;
  const end = pageSize * pageNumber;
  return detailList.slice(start, end);
}
export function SetTapsPndTable(tableView: PndTableViewStatusType, countTable: any) {
  const taps = [
    {
      name: "Table_Tap_All",
      length: countTable,
      bgLengthColor: "blue",
      showtableCount: false,
      tableViewStatusType: PndTableViewStatusType.All,
      active: true,
    },
    {
      name: "Table_Tap_Draft",
      length: countTable,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: PndTableViewStatusType.Draft,
      active: false,
    },
    {
      name: "Table_Tap_AwaitApprove",
      length: countTable,
      bgLengthColor: "blue",
      showtableCount: false,
      tableViewStatusType: PndTableViewStatusType.AwaitApproval,
      active: false,
    },
    {
      name: "Table_Tap_AwaitFiling",
      length: countTable,
      bgLengthColor: "orange",
      showtableCount: false,
      tableViewStatusType: PndTableViewStatusType.AwaitFiling,
      active: false,
    },
    {
      name: "Table_Tap_AwaitPayment",
      length: countTable,
      bgLengthColor: "orange",
      showtableCount: false,
      tableViewStatusType: PndTableViewStatusType.AwaitPayment,
      active: false,
    },
    {
      name: "Table_Tap_TaxPaid",
      length: countTable,
      bgLengthColor: "blue",
      showtableCount: false,
      tableViewStatusType: PndTableViewStatusType.Paid,
      active: false,
    },
    {
      name: "Table_Tap_Void",
      length: countTable,
      bgLengthColor: "blue",
      showtableCount: false,
      tableViewStatusType: PndTableViewStatusType.Voided,
      active: false,
    },
  ];

  return taps;
}
export function SetHeaderPndTable() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "Number_Form",
      sortBy: PndTableSortColumnType.PndNumber,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Tax_Period",
      sortBy: PndTableSortColumnType.PndDate,
      sortingType: null,
      align: "center",
    },
    {
      name: "Item",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "Payment_Amount",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "WHT",
      sortBy: null,
      sortingType: null,
      align: "flex-end",
    },
    {
      name: "Status",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
      isSetPadding: true,
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  return header;
}

export function ConvertToInsertPnd(insertPndTemplate: any) {
  const insertPndModel = {
    pndNumber: insertPndTemplate.number.value,
    pndType: insertPndTemplate.pndType,
    pndDate: insertPndTemplate.taxPeriodDate.value.ToDateJsonString(),
    subTotal: insertPndTemplate.subTotal.value.ToNumber(),
    whtTotal: insertPndTemplate.whtTotal.value.ToNumber(),
    surchargeAmount: insertPndTemplate.surchargeAmount.value.ToNumber(),
    netAmount: insertPndTemplate.netAmount.value.ToNumber(),
    status: insertPndTemplate.status,
    filingType: insertPndTemplate.filingType.value,
    filingRound: insertPndTemplate.times.value,
    filingCaseType: insertPndTemplate.filingTaxSection,
    whtForInsertPndModelList: [] as any,
    id: insertPndTemplate.id,
  };
  insertPndTemplate.whtCertificateList.forEach((item: any) => {
    insertPndModel.whtForInsertPndModelList.push({
      whtCertificateId: item.id,
      sourceId: item.sourceId,
      sourceType: item.sourceType,
      whtDate: item.whtDate,
    });
  });
  return insertPndModel;
}

export function SetPndDetailForEdit(pndDetail: any) {
  const pndTemplate = GetPndCreateTemplate();

  pndTemplate.id = pndDetail.pndId;
  pndTemplate.pndType = pndDetail.pndType;
  pndTemplate.taxPeriodDate.value = new Date(pndDetail.pndDate);
  pndTemplate.filingType.value = pndDetail.filingType;
  pndTemplate.times.value = pndDetail.filingRound;
  pndTemplate.number.value = pndDetail.pndNumber;
  pndTemplate.subTotal.value = pndDetail.subTotal.FormatMoney();
  pndTemplate.whtTotal.value = pndDetail.whtTotal.FormatMoney();
  pndTemplate.surchargeAmount.value = pndDetail.surchargeAmount.FormatMoney();
  pndTemplate.netAmount.value = pndDetail.netAmount;
  pndTemplate.status = pndDetail.status;
  pndTemplate.filingTaxSection = pndDetail.filingCaseType;
  pndTemplate.countWhtCertificate = pndDetail.countWhtCertificate;
  pndTemplate.whtCertificateList = pndDetail.whtForInsertPndModelList;

  return pndTemplate;
}

export function GetFilingCaseTypeName(filingCaseType: FilingCaseType) {
  let filingCaseTypeName: any = "";
  switch (filingCaseType) {
    case FilingCaseType.M3Sec3:
      filingCaseTypeName = i18n.t("M3_Sec3");
      break;
    case FilingCaseType.M48Sec2:
      filingCaseTypeName = i18n.t("M48_Sec2");
      break;
    case FilingCaseType.M50:
      filingCaseTypeName = i18n.t("M50_3_4_5");

      break;
    case FilingCaseType.M65Sec4:
      filingCaseTypeName = i18n.t("M65_Sec4");
      break;
    case FilingCaseType.M69Sec2:
      filingCaseTypeName = i18n.t("M69_Sec2");
      break;
  }
  return filingCaseTypeName;
}

export function GetPndType(pndType: PndType) {
  let pndName: any = "";
  switch (pndType) {
    case PndType.PND1:
      pndName = i18n.t("PND_No", { pndNo: "1" });
      break;
    case PndType.PND2:
      pndName = i18n.t("PND_No", { pndNo: "2" });
      break;
    case PndType.PND2kor:
      pndName = i18n.t("PND_No", { pndNo: "2ก" });
      break;
    case PndType.PND3:
      pndName = i18n.t("PND_No", { pndNo: "3" });
      break;
    case PndType.PND3kor:
      pndName = i18n.t("PND_No", { pndNo: "3ก" });
      break;
    case PndType.PND53:
      pndName = i18n.t("PND_No", { pndNo: "53" });
      break;
    case PndType.PND54:
      pndName = i18n.t("PND_No", { pndNo: "54" });
      break;
  }

  return pndName;
}

export function GetPndTypeText(pndType: PndType) {
  let pndText: any = "";
  switch (pndType) {
    case PndType.PND1:
      pndText = "PND_1";
      break;
    case PndType.PND2:
      pndText = "PND_2";
      break;
    case PndType.PND2kor:
      pndText = "PND_2_Kor";
      break;
    case PndType.PND3:
      pndText = "PND_3";
      break;
    case PndType.PND3kor:
      pndText = "PND_3_Kor";
      break;
    case PndType.PND53:
      pndText = "PND_53";
      break;
    case PndType.PND54:
      pndText = "PND_54";
      break;
  }

  return pndText;
}

export function CompareWhtDetailForPnd(whtCertificate: any, wht: any) {
  const isDeleted = wht.isDeleted;
  const validateDate = whtCertificate.whtDate.ToDateJsonString() == wht.date.ToDateJsonString();
  const validateNumber = whtCertificate.whtNumber == wht.number;
  const validateSubTotalForCalculateWht =
    whtCertificate.subTotal.FormatMoney().ToNumber() == wht.subTotalForCalculateWht.FormatMoney().ToNumber();
  const validateWhtTotal = whtCertificate.whtTotal.FormatMoney().ToNumber() == wht.whtTotal.FormatMoney().ToNumber();

  let verifyType = VerifyType.Success;
  let verifyText: any = "";

  if (isDeleted) {
    verifyType = VerifyType.Fail;
    verifyText = i18n.t("Data_From_PEAK_Discontinued");
  } else if (validateDate && validateNumber && validateSubTotalForCalculateWht && validateWhtTotal) {
    verifyType = VerifyType.Success;
    verifyText = i18n.t("This_Item_Has_Been_Validated");
  } else {
    verifyType = VerifyType.Warn;
    verifyText = i18n.t("Data_From_PEAK_Has_Changed");
  }

  whtCertificate.verifyType = verifyType;
  whtCertificate.verifyText = verifyText;
}

export function CompareWhtContact(whtCertificateList: any, whtCertificate: any, index: any) {
  let verifyContactType = VerifyType.Success;
  let verifyContactText: any = i18n.t("This_Item_Has_Been_Validated");
  const whtCertificateMockupList = NewObject(whtCertificateList);
  if (index > -1) {
    whtCertificateMockupList.splice(index, 1);
  }
  const whtCertificateMockupListMapContact = whtCertificateMockupList.filter(
    (x: any) => x.contactId === whtCertificate.contactId
  );
  if (whtCertificateMockupListMapContact && whtCertificateMockupListMapContact.length > 0) {
    const whtCertificateDate = whtCertificate.whtDate ? whtCertificate.whtDate.ToDateJsonString() : "";
    const whtCertificateMockupListMapDate = whtCertificateMockupListMapContact.filter((x: any) => {
      const itemDate = x.whtDate ? x.whtDate.ToDateJsonString() : "";
      if (itemDate && whtCertificateDate && itemDate === whtCertificateDate) {
        return true;
      }
    });

    if (whtCertificateMockupListMapDate && whtCertificateMockupListMapDate.length > 0) {
      const whtCertificateMockup = whtCertificateMockupListMapDate.find(
        (x: any) => x.whtTotal == whtCertificate.whtTotal
      );

      if (whtCertificateMockup) {
        verifyContactType = VerifyType.Fail;
        verifyContactText = i18n.t("Have_Contact_WHT_Issue_Date_And_Amount_Are_Same");
      } else {
        verifyContactType = VerifyType.Warn;
        verifyContactText = i18n.t("Have_Contact_WHT_Issue_Date_Are_Same_But_Amount_Not_Same");
      }
    } else {
      const whtCertificateMockup = whtCertificateMockupListMapContact.find(
        (x: any) => x.whtTotal == whtCertificate.whtTotal
      );

      if (whtCertificateMockup) {
        verifyContactType = VerifyType.Warn;
        verifyContactText = i18n.t("Have_Contact_WHT_Issue_Amount_Are_Same_But_Day_Issued");
      }
    }
  }

  whtCertificate.verifyContactType = verifyContactType;
  whtCertificate.verifyContactText = verifyContactText;

  return new Promise((resolve, reject) => {
    return setTimeout(() => {
      resolve(true);
    }, 0);
  });
}

export async function VerifiedWhtDetailListForPnd(
  whtCertificate: any,
  whtCertificateList: any,
  whtDetailListForPnd: any,
  index: any
) {
  let wht: any;
  await CompareWhtContact(whtCertificateList, whtCertificate, index);
  if (whtDetailListForPnd && whtDetailListForPnd.length > 0) {
    wht = whtDetailListForPnd.find((x: any) => x.id === whtCertificate.sourceId);
  }
  if (wht) {
    CompareWhtDetailForPnd(whtCertificate, wht);
  } else {
    whtCertificate.verifyType = VerifyType.Success;
    whtCertificate.verifyText = i18n.t("This_Item_Has_Been_Validated");
  }

  return new Promise((resolve, reject) => {
    return setTimeout(() => {
      resolve(true);
    }, 0);
  });
}

export function GetPndStatus(pndStatus: PndStatus) {
  let statusName: any = "";
  let className = "";

  switch (pndStatus) {
    case PndStatus.Draft:
      statusName = i18n.t("Table_Tap_Draft");
      className = "statusDraft";
      break;
    case PndStatus.AwaitApproval:
      statusName = i18n.t("Table_Tap_AwaitApprove");
      className = "statusAwaitApproval";
      break;
    case PndStatus.AwaitFiling:
      statusName = i18n.t("Table_Tap_AwaitFiling");
      className = "statusAwaitFiling";
      break;
    case PndStatus.Filed:
      statusName = i18n.t("Table_Tap_FiledTax");
      className = "statusFiledTax";
      break;
  }

  return { name: statusName, class: className };
}
